const PLUGIN_NAME = 'ecommerce-context';
const LOCAL_CART_KEY = 'blaze_cart_id';
const LOCAL_CURRENCY_KEY = 'blaze_cart_currency_code';
const LOCAL_CART_UPDATED_KEY = 'blaze_cart_updated';
const CONTEXT_KEYS = {
  currencyKey: 'currency',
  variantKey: 'variant',
  cartIdKey: 'cartId',
  cartDataKey: 'cartData'
};
const DEFAULT_CURRENCY = 'gbp';

const EVENT_NAMES = {
  create_cart: 'create_cart',
  add_to_cart: 'add_to_cart',
  remove_from_cart: 'remove_from_cart',
  update_cart: 'update_cart',
  begin_checkout: 'begin_checkout',
  add_payment_info: 'add_payment_info',
  purchase: 'purchase',
  select_promotion: 'select_promotion',
  remove_promotion: 'remove_promotion',
  view_cart: 'view_cart'
};

const EVENT_PREFIX = 'plugin:ecommerce:event:';

export {
  PLUGIN_NAME,
  LOCAL_CART_KEY,
  LOCAL_CURRENCY_KEY,
  LOCAL_CART_UPDATED_KEY,
  CONTEXT_KEYS,
  DEFAULT_CURRENCY,
  EVENT_NAMES,
  EVENT_PREFIX
};
